import { SagaIterator } from 'redux-saga';
import {
  put,
  call,
  takeLatest,
  StrictEffect,
  select,
  delay,
  CallEffect,
  SelectEffect,
  PutEffect,
  cancel,
  race,
  take,
  cancelled,
  CancelledEffectDescriptor,
  SimpleEffect,
} from 'redux-saga/effects';
import {
  fetchAllReports,
  fetchAllReportsError,
  fetchAllReportsSuccess,
  fetchLatestReportError,
  fetchLatestReport,
  fetchLatestReportSuccess,
  fetchLatestDashboard,
  fetchLatestDashboardSuccess,
  fetchLatestDashboardError,
  fetchReportSettingsError,
  fetchReportSettings,
  fetchReportSettingsSuccess,
  fetchSpecificDashboard,
  fetchSpecificReport,
  fetchSpecificDashboardError,
  fetchSpecificDashboardSuccess,
  fetchSpecificReportError,
  fetchSpecificReportSuccess,
  updateReportSettings,
  updateReportSettingsSuccess,
  updateReportSettingsError,
  fetchLatestReportByGroup,
  fetchSpecificReportByGroup,
  fetchLatestReportByGroupSuccess,
  fetchLatestReportByGroupError,
  fetchSpecificReportByGroupSuccess,
  fetchSpecificReportByGroupError,
  runAutomatedAudit,
  runAutomatedAuditSuccess,
  runAutomatedAuditError,
  fetchLatestReportRetry,
  automatedAuditStatus,
  automatedAuditStatusSuccess,
  automatedAuditStatusError,
  fetchTotalReportsSuccess,
  fetchTotalReportsError,
  fetchTotalReports,
  fetchAuditEngine,
  fetchAuditEngineSuccess,
  fetchAuditEngineError,
  fetchResolvedReportsSuccess,
  fetchResolvedReportsError,
  fetchResolvedReports,
  setDefault,
  fetchAuditLenghtError,
  fetchAuditLenght,
  fetchAuditLenghtSuccess,
  singlePageAudit,
  reauditCriteriaPages,
  reauditCriteriaPagesError,
  reauditCriteriaPagesSuccess,
  _updateReportSettingsState
} from './index';
import { apiInstance } from 'src/services/interceptor';
import { PayloadAction } from '@reduxjs/toolkit';
import { IReport } from './types';
import { IUserData } from '@common/types/types';
import { paymentInfoAction } from '../payment';
import stopAudit, { stopAuditError, stopAuditSuccess } from '../stopAudit';
import i18n from '@common/i18n/config';
import dayjs from 'dayjs';
import { currentAction } from '../user';

interface getAllReportsPayload {
  id: string;
  params: {
    datefrom: string;
    dateTo: string;
  };
}

interface LatestReportResponse {
  data: IReport[];
}

function* getAllReports({ payload }: PayloadAction<getAllReportsPayload>): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    const response = yield call(apiInstance, `/reporttool/audit/runs/${payload.id}`, {
      params: payload.params,
    });    
    yield put(fetchAllReportsSuccess(Array.isArray(response.data) ? response.data : []));
  } catch (e) {
    yield put(fetchAllReportsError());
  }
}

function* getLatestReport({ payload }: any): SagaIterator {
  try {

    const user = yield select((state) => state.user.data);
    const response = yield call(apiInstance, `reporttool/latest/issues/${user.tenantId}/${payload.id}`, {
      params: payload.params ?? {},
    });   
    
    yield put(fetchLatestReportSuccess(response.data));
  } catch (e) {
    // payload?.errorMessage('')
    yield put(fetchLatestReportError());
  }
}

function* getLatestDashboard({ payload }: any): Generator<SelectEffect | CallEffect<unknown> | PutEffect, any, any> {
  try {
    const siteUUID = payload?.id?.siteUUID ?? payload?.id;
    const user = yield select((state) => state.user.data);
    const response = yield call(apiInstance, `reporttool/dashboard/latest/run/${siteUUID}`, {
      params: { lang: i18n.language } ?? {},
    });
    // we checked if is loading come with results it's not matter if is it tru or false
    if ( response.data.isLoading || response.data.isLoading == false) {
      const runsResponse = yield call(apiInstance, `/reporttool/audit/runs/${siteUUID}`, {
        params: {
          datefrom: dayjs(new Date(new Date().setDate(new Date().getDate() - 7))).format('YYYY-MM-DD'),
          dateTo: dayjs(new Date()).format('YYYY-MM-DD'),
          order: 'desc',
        },
      });
       
      if (runsResponse?.data[0]?.id && runsResponse?.data[0]?.siteUUID && runsResponse?.data[0]?.id  ) {
        yield put(automatedAuditStatus({ siteId: runsResponse.data[0].siteUUID, reportId: runsResponse.data[0].id }));
      }
    } else {
      yield put(fetchLatestDashboardSuccess(response.data));
    }
  } catch (e) {
    yield put(fetchLatestDashboardError());
  }
}

function* getReportSettingsDashboard({ payload }: PayloadAction<string>): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    const siteUUID: any = yield select((state) => state.user.siteUUID);
    const response = yield call(apiInstance, `reporttool/settings/${siteUUID}`);    
    yield put(fetchReportSettingsSuccess(response?.data));
  } catch (e) {
    yield put(fetchReportSettingsError());
  }
}

interface getSpecificReportPayload {
  id: string;
  runId: string;
  tracking_number : number;
  params?: { [key: string]: string };
}

function* getSpecificReport({ payload }: PayloadAction<getSpecificReportPayload>): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    // const response = yield call(apiInstance, `reporttool/run/issues/${user.tenantId}/${payload.id}/${payload.runId}`, {
    //   params: { ...payload.params, lang: i18n.language } ?? {},
    // });    
    const response = yield call(apiInstance.post, `reporttool/usermanagement/issues/getmapbasedoncriterias`, { 
      // tenantId : user.tenantId,
      siteUUID : payload.id, 
      report_id: payload.runId,
      // trackingNumber : payload.tracking_number
  });

    yield put(fetchSpecificReportSuccess({mapData:response.data?.mapData , reportId : response.data?.reportId}));
  } catch (e) {
    yield put(fetchSpecificReportError());
  }
}

function* getSpecificDashboard({ payload }: PayloadAction<getSpecificReportPayload>): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    const response = yield call(
      apiInstance,
      `reporttool/dashboard/run/${payload.id}/${payload.runId}`,
    );
    yield put(fetchSpecificDashboardSuccess(response.data));
  } catch (e) {
    yield put(fetchSpecificDashboardError());
  }
}

interface updateSettingsPayload {
  id: string;
  data: { [key: string]: string };
  successMessage?: ()=>void;
  errorCallback?: (value:string)=>void;
}

function* updateSettings({ payload }: PayloadAction<updateSettingsPayload>): SagaIterator {
  try {     
    const response = yield call(apiInstance.put, `reporttool/settings/${payload.id}`, payload.data);
    if ( response?.data?.site?.id ) {
      payload?.successMessage?.()
      yield put(updateReportSettingsSuccess(response.data));
      // yield put(_updateReportSettingsState())
      return
    }
  } catch (e:any) {
    console.log( e);
    
    const errorMessage = e?.data?.message ?? 'Enable To Update Report Settings';
    payload?.errorCallback?.(errorMessage)
    yield put(updateReportSettingsError(errorMessage));
    // yield put(_updateReportSettingsState())
  }
}

function* getLatestReportGrouped({ payload }: PayloadAction<getSpecificReportPayload>): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    const response = yield call(apiInstance, `reporttool/latest/issues/group/${user.tenantId}/${payload.id}`, {
      params: { ...payload.params, lang: i18n.language } ?? {},
    });
    yield put(fetchLatestReportByGroupSuccess(response.data));
  } catch (e) {
    yield put(fetchLatestReportByGroupError());
  }
}

function* getSpecificReportGrouped({ payload }: PayloadAction<getSpecificReportPayload>): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    const response = yield call(
      apiInstance,
      `reporttool/issues/group/run/${user.tenantId}/${payload.id}/${payload.runId}`,
      { params: { ...payload.params, lang: i18n.language } ?? {} },
    );
    yield put(fetchSpecificReportByGroupSuccess(response.data.slice(0, 10)));
  } catch (e) {
    yield put(fetchSpecificReportByGroupError());
  }
}

function* runAudit({ payload }: PayloadAction<any>): SagaIterator {
  try {
    // const user = yield select((state) => state.user.data);
    const response = yield call(apiInstance.post, `reporttool/audit/run`,  {
      // site_id : payload.id,
      // tenant_id: user.tenantId,
      siteUUID: payload.siteUUID,
      // organization_Id: payload?.organization_Id ?  payload?.organization_Id : null,
    });
    if ( (response && response.status != 200) || ( !response?.data?.siteUUID || !response?.data?.id ) ) {
      payload?.ErrorMessage?.()
      yield put(runAutomatedAuditError(response?.data?.body?.message ?? "Enable To Start The Audit,Please Try Later."));
      return
    }else {     
      payload?.successMessage?.() 
      yield put(runAutomatedAuditSuccess(response.data));
      yield put(automatedAuditStatus({ siteId: response.data.siteUUID, reportId: response.data.id }));
      yield put(fetchLatestReportRetry({ id: payload }));
      return
    }
  } catch (e) {
    payload?.ErrorMessage?.()
    yield put(runAutomatedAuditError('error'));
  }
}

function* getLatestReportWithRetry({
  payload,
}: any): Generator<SelectEffect | CallEffect<unknown> | IReport[], any, any> {
  while (true) {
    try {

      const user: IUserData = yield select((state) => state.user.data);
      const siteUUID: any = yield select((state) => state.user.siteUUID);
      const response = yield call(apiInstance.post, `reporttool/usermanagement/issues/getmapbasedoncriterias`, {
          // tenantId : user.tenantId,
          // siteId : payload.id,
          siteUUID
      });      
      if (response.data.isLoading) {
        
        throw 'Retry';
      }
      return {data:{mapData:response.data?.mapData , reportId : response?.data?.reportId }};
    } catch (e) {
      if (e === 'Retry') {
        yield delay(10000);
      } else {
        throw new Error('Retry');
      }
    }
  }
}

function* getAuditStatus({ payload }: any): any {
  
  while (true) {
    try {
      const response = yield call(apiInstance, `reporttool/audit/status/${payload.siteId}/${payload.reportId}${payload.isPage ? '?isPage=1' : ''}`);
    
      if (response?.status === 200 
        && response?.data?.instance_status !== 'shutting-down' 
        && response?.data?.instance_status !== 'terminated' 
        && response?.data?.instance_status !== 'not_found'
        && response?.data?.instance_status !== 'not found'
        && response?.data?.instance_status !== 'not running'
        ) {
        
        const statusProgress = response.data.status.split('%')[0];
        if (isNaN(statusProgress) || Number(statusProgress) < 100) {
          yield put(automatedAuditStatusSuccess(response.data));
          yield delay(3000);
        } else {
          // don't break the loop till you get the reports ready.
          const dashboardData = yield call(apiInstance, `reporttool/dashboard/latest/run/${payload.siteId}?lang=en`);
          if (dashboardData.status === 200 && dashboardData.data?.ialabsScore) {
            yield put(automatedAuditStatusSuccess(response.data));
            // yield put(currentAction()) 
            yield put(paymentInfoAction({
              submitCallback : ()=>{}
            }));
            yield cancel();
          }
          yield delay(3000);
        }
      }else { 
        yield put(automatedAuditStatusError());
        yield put(fetchLatestDashboardError());
        yield put(runAutomatedAuditError('error'));
        yield cancel();
      }
    } catch (e) {
      yield put(automatedAuditStatusError());
      yield put(fetchLatestDashboardError());
      yield put(runAutomatedAuditError('error'));
      yield cancel();
    }
  }
}

function* getLatestReportRetry({
  payload,
}: PayloadAction): Generator<
  CallEffect<unknown> | PutEffect | SimpleEffect<'CANCELLED', CancelledEffectDescriptor>,
  void,
  LatestReportResponse
> {
  try {
    const apiRes: LatestReportResponse = yield call(getLatestReportWithRetry, { payload });  
    yield put(fetchLatestReportSuccess(apiRes.data));
    yield call(getLatestDashboard, { payload });
    yield put(paymentInfoAction({
      submitCallback : ()=>{}
    }));
  } catch (e) {
    yield put(fetchLatestReportError());
  }
}

function* getTotalReports(): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    const response = yield call(apiInstance, `/reporttool/totalissues/${user.tenantId}`);
    yield put(fetchTotalReportsSuccess(response.data));
  } catch (e) {
    yield put(fetchTotalReportsError());
  }
}
function* getResolvedReports(): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    const response = yield call(apiInstance, `/reporttool/totalfix/${user.tenantId}`);
    yield put(fetchResolvedReportsSuccess(response.data));
  } catch (e) {
    yield put(fetchResolvedReportsError());
  }
}

function* getAuditEngine(): SagaIterator {
  try {
    const response = yield call(apiInstance, `reporttool/compliance-levels`);
    yield put(fetchAuditEngineSuccess(response.data));
  } catch (e) {
    yield put(fetchAuditEngineError());
  }
}

function* getAuditStatusWithCancel({ payload }: any): SagaIterator {
  yield race([take(stopAuditSuccess), take(setDefault), call(getAuditStatus, { payload })]);
}

function* getAuditLenght( {payload} : any): SagaIterator {
  try {

    const user = yield select((state) => state.user.data);

    const reqBody = payload.runId && payload.tracking_number ? {
                      report_id :payload.runId,
                      tracking_number: payload.tracking_number
                    } : {};
    const response = yield call(apiInstance.post, `/reporttool/auditTime/${user.tenantId}/${payload.id}`,reqBody
    );
    if(response.data.status != 200){
        throw new Error('error');
        yield cancel();
    }
    yield put(fetchAuditLenghtSuccess(response.data.body));
  } catch (e) {
    yield put(fetchAuditLenghtError());
  }
}

function* runSingleAuditSaga({ payload : { companyId  , siteUUID, reportId, pageURL , errorCallback } }: PayloadAction<any>): SagaIterator {
  try {
    const user = yield select((state) => state.user.data);
    const response = yield call(
      apiInstance.post,
      `reporttool/audit/reaudit-page`,
      {
        companyId,
        siteUUID,
        reportId,
        pageURL
      }
    );
    if ( response && response.status === 200 ) {
      yield put(runAutomatedAuditSuccess(response.data));
      yield put(automatedAuditStatus({ siteId: siteUUID, reportId , isPage : "1" }));
      yield put(fetchLatestReportRetry({ id: { site_id :pageURL  } }));   
      // yield put(fetchLatestReportRetry({ id: { id : site_id }  }));

      return
    }
    errorCallback?.(`Enable Start Audit. Please try Later.`)
    yield put(runAutomatedAuditError("Somthings went wrong!!"));
 
  } catch (e) {
    errorCallback?.(`Enable Start Audit. Please try Later.`)
    yield put(runAutomatedAuditError("Somthings went wrong!!"));
  }
}
function* reAuditSpecificPagesCriteriasSaga({ payload : {  site_id ,  report_id , companyId, siteUUID, specificPages , specificCriterias , errorCallback  } }: PayloadAction<any>): SagaIterator {
  try {
    // const user = yield select((state) => state.user.data);

    const response = yield call(
      apiInstance.post,
      `reporttool/audit/reaudit-specific-pages-criterias`,
      {
        // site_id,
        companyId,
        siteUUID,
        report_id,
        specificPages,
        specificCriterias
      }
    );
    if ( (response && response.status != 200) ) {
      errorCallback?.(`Enable Start Audit. Please try Later.`)
      yield put(reauditCriteriaPagesError('error'));
      return
    }else {
      yield put(reauditCriteriaPagesSuccess(response.data));
      // yield put(automatedAuditStatus({ siteId: site_id, reportId: report_id , isPage : true }));
      return
    }
  } catch (e) {
    errorCallback?.(`Enable Start Audit. Please try Later.`)
    yield put(reauditCriteriaPagesError('error'));
  }
}
function* automatedReportsSaga(): Generator<StrictEffect, void> {
  yield takeLatest(fetchAllReports.type, getAllReports);
  yield takeLatest(fetchLatestReport.type, getLatestReport);
  yield takeLatest(fetchLatestDashboard.type, getLatestDashboard);
  yield takeLatest(fetchReportSettings.type, getReportSettingsDashboard);
  yield takeLatest(fetchSpecificReport.type, getSpecificReport);
  yield takeLatest(fetchSpecificDashboard.type, getSpecificDashboard);
  yield takeLatest(updateReportSettings.type, updateSettings);
  yield takeLatest(fetchLatestReportByGroup.type, getLatestReportGrouped);
  yield takeLatest(fetchSpecificReportByGroup.type, getSpecificReportGrouped);
  yield takeLatest(fetchAuditEngine.type, getAuditEngine);
  yield takeLatest(runAutomatedAudit.type, runAudit);
  yield takeLatest(fetchLatestReportRetry.type, getLatestReportRetry);
  yield takeLatest(fetchTotalReports.type, getTotalReports);
  yield takeLatest(fetchResolvedReports.type, getResolvedReports);
  yield takeLatest(automatedAuditStatus.type, getAuditStatusWithCancel);
  yield takeLatest(fetchAuditLenght.type, getAuditLenght);
  yield takeLatest(singlePageAudit.type, runSingleAuditSaga);
  yield takeLatest(reauditCriteriaPages.type, reAuditSpecificPagesCriteriasSaga);
}

export { automatedReportsSaga };
